
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...uri]",
      function () {
        return require("private-next-pages/[...uri].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...uri]"])
      });
    }
  